import { useCallback, useRef } from "react"

const DRAG_THRESHOLD_PX = 8

// Todo: move to a util?
/**
 * Suppresses the synthetic click after a primary-button drag (e.g. horizontal
 * carousel scroll) so full-card / overlay links do not navigate. Attach
 * `onPointerDownCapture` and `onClickCapture` on a common ancestor of those links.
 */
export function useSuppressNavigationClickAfterDrag() {
  const pointerDownRef = useRef<{ x: number; y: number } | null>(null)

  const onPointerDownCapture = useCallback((event: React.PointerEvent) => {
    if (event.button !== 0) return
    pointerDownRef.current = { x: event.clientX, y: event.clientY }

    window.addEventListener(
      "pointerup",
      () => {
        window.setTimeout(() => {
          pointerDownRef.current = null
        }, 0)
      },
      { capture: true, once: true }
    )
  }, [])

  const onClickCapture = useCallback((event: React.MouseEvent) => {
    const start = pointerDownRef.current
    pointerDownRef.current = null
    if (!start) return
    const dx = event.clientX - start.x
    const dy = event.clientY - start.y
    // If we've moved more than the drag threshold,
    // assume this is a drag and prevent the default click behavior
    if (Math.hypot(dx, dy) > DRAG_THRESHOLD_PX) {
      event.preventDefault()
      event.stopPropagation()
    }
  }, [])

  return { onPointerDownCapture, onClickCapture }
}
